import React from 'react'
import { useDispatch } from 'react-redux'
import { inputTypes } from '@easybutton/constants'

import { getId } from '../../../utils/ids'
import { addInput } from '../../../ducks/actions'

import Form from './Form'

export default function AddInputModal({
  onSuccess,
  onCancel,
  actionId,
  suggestedName,
}) {
  const dispatch = useDispatch()

  const handleSubmit = async ({ input: values }) => {
    const input = { ...values, id: getId() }

    await dispatch(addInput(actionId, input))

    onSuccess(input)
  }

  const type =
    suggestedName && suggestedName.match(/password/i)
      ? inputTypes.PASSWORD
      : inputTypes.TEXT

  const initialValues = {
    input: {
      name: suggestedName || 'My New Input',
      type,
    },
  }

  return (
    <Form
      onSubmit={handleSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
    />
  )
}
